export enum PatientAppUserChannel {
  CREATE = 'patientAppUser::create',
  EDIT = 'patientAppUser::patch',
  DELETE = 'patientAppUser::delete',
}
